<template>
    <div class="automation-block-editor loop">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Loop Type:</div>
            <CustomPicker v-model="clone.mode" :items="loopType" idKey="id" labelKey="label" title="Select Loop Type" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Trim Whitespace</div>
            <a-switch v-model="clone.options.trimWhitespace" />
        </div>
        <div class="editor-row customize-editor-minimize" key="clone.options.iterationCounterStart">
            <div class="editor-row-title">Loop Iteration Counter Start</div>
            <TiptapEditor
                placeholder="Loop Iteration Counter Start"
                :show-attributes="true"
                v-model="clone.options.iterationCounterStart"
                automation-mode
                :show-emoji="false"
            />
            <small class="description">
                A counter value called 'loop_iteration' will be added to each iteration of the loop. Does not affect the
                data to loop through. Defaults to '0'.
            </small>
        </div>
        <div class="editor-row customize-editor-minimize" key="clone.options.maximumIterations">
            <div class="editor-row-title">Max Number of Loop Iteration</div>
            <TiptapEditor
                placeholder="Max Number of Loop Iteration"
                :show-attributes="true"
                v-model="clone.options.maximumIterations"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">
                Set this value to limit the number of loops performed. Data in iterations past the limit will be
                ignored. A number higher than 500 will be reduced to 500. A number less than 1 will halt this step.
            </small>
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'numbers'" key="clone.number.end">
            <div class="editor-row-title">Loop Iteration Counter End</div>
            <TiptapEditor
                placeholder="Loop Iteration Counter End"
                :show-attributes="true"
                v-model="clone.number.end"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">
                Set the iteration number to end the loop at here. Defaults to '1'. Cannot be less than Loop iteration
                counter start.
            </small>
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'numbers'" key="clone.number.increment">
            <div class="editor-row-title">Loop iteration counter increment amount</div>
            <TiptapEditor
                placeholder="Loop iteration counter increment amount"
                :show-attributes="true"
                v-model="clone.number.increment"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">
                Set the amount to increment the counter for each iteration of the loop. Defaults to '1'. Cannot be '0'
                or negative. Must be an whole number.
            </small>
        </div>

        <div class="editor-row customize-editor-minimize data-items" v-if="clone.mode === 'line-items'">
            <div class="editor-row-title">Line Item(s) to Loop</div>
            <DataItem
                v-for="(item, index) in clone.items || []"
                v-model="clone.items[index]"
                :key="index"
                @delete="() => clone.items.splice(index, 1)"
            />
            <SupsisButton small ghost @click="addItem"> Add Item</SupsisButton>
        </div>
        <div class="editor-row customize-editor-minimize data-items" v-if="clone.mode === 'text'">
            <div class="editor-row-title">Text to Loop</div>
            <DataItem
                v-for="(item, index) in clone.items || []"
                v-model="clone.items[index]"
                :key="index"
                @delete="() => clone.items.splice(index, 1)"
            />
            <SupsisButton small ghost @click="addItem" v-if="(clone.items || []).length < 1"> Add Item</SupsisButton>
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'text'" key="clone.text.delimiter">
            <div class="editor-row-title">Text Delimiter</div>
            <TiptapEditor
                placeholder="Text Delimiter"
                :show-attributes="true"
                v-model="clone.text.delimiter"
                :show-emoji="false"
                automation-mode
            />
            <small class="description"> Supports special characters. Defaults to ',' </small>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import DataItem from "../webhook/DataItem.vue";

const log = log2("Loop");
export default {
    name: "Loop",
    components: { DataItem, SupsisButton, CustomPicker, TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "line-items", //line-items,numbers,text
            options: {
                iterationCounterStart: 0,
                maximumIterations: 500,
                trimWhitespace: true,
            },
            number: {
                start: 0,
                end: 10,
                increment: 1,
            },
            items: [],
            text: {
                delimiter: ",",
            },
        };
        return {
            clone,
            loopType: [
                { id: "line-items", label: "Line Items", description: "Create loop from line Item(s)" },
                { id: "numbers", label: "Numbers", description: "Create loop from number range" },
                { id: "text", label: "Text", description: "Create loop from text" },
            ],
        };
    },
    methods: {
        addItem() {
            this.clone.items.push({ key: null, value: null });
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.loop {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        small.description {
            font-size: 10px;
            color: var(--color-text-weak-default);
        }

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
